import { render, staticRenderFns } from "./Step5Image.vue?vue&type=template&id=bedbe960&"
import script from "./Step5Image.vue?vue&type=script&lang=js&"
export * from "./Step5Image.vue?vue&type=script&lang=js&"
import style0 from "./Step5Image.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports